export class BufferedCommandJs {
    bufferingPeriod: () => number;
    heartbeatPeriod: () => number;
    execute: () => void;
    bufferingTimer: Timer;
    heartbeatTimer: Timer;
    running: boolean = false;

    constructor(bufferingPeriod: () => number, heartbeatPeriod: () => number, execute: () => void) {

        this.bufferingPeriod = bufferingPeriod;
        this.heartbeatPeriod = heartbeatPeriod;

        this.bufferingTimer = new Timer(() => {
            this.heartbeatTimer.cancel();
            this.doExecute();
        });
        this.heartbeatTimer = new Timer(() => {
            this.bufferingTimer.cancel();
            this.doExecute();
        });
        this.execute = execute;
    }

    doExecute() {
        this.execute();
        this.running = false;
    }

    destroy() {
        if (this.running) {
            if (this.bufferingTimer !== null) {
                this.bufferingTimer.cancel();
            }
            if (this.heartbeatTimer !== null) {
                this.heartbeatTimer.cancel();
            }
        }
    }

    force() {
        this.bufferingTimer.cancel();
        this.heartbeatTimer.cancel();
        this.doExecute();
    }

    invoke() {
        if (this.running) {
            this.heartbeatTimer.cancel();
        } else {
            this.running = true;
            this.bufferingTimer.schedule(this.bufferingPeriod());
        }

        this.heartbeatTimer.schedule(this.heartbeatPeriod());
    }
}

class Timer {
    callback: Function;
    timer?: number;

    constructor(callback: Function) {
        this.callback = callback;
    }

    schedule(timeout: number) {
        this.cancel();
        this.timer = setTimeout(this.callback, timeout);
    }

    cancel() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = 0;
        }
    }
}
